import { useState } from 'react'
import { Button } from 'components/ui/button'
import { Input } from 'components/ui/input'
import { updateReport } from 'store/reports/reportsSlice'
import { useAppDispatch } from 'store/store'

export const SolveReportForm: React.FC<{ id?: number }> = ({ id }) => {
  const [admin_notes, setAdminNotes] = useState('')
  const dispatch = useAppDispatch()

  const isValid = () => admin_notes !== ''

  const save = (event: React.FormEvent<HTMLButtonElement>): void => {
    event.preventDefault()
    if (id) {
      dispatch(updateReport({ id, admin_notes }))
    }
  }

  return (
    <form className='flex max-w-xl flex-col gap-10'>
      <p>
        <strong>Note:</strong>
        <Input
          type='text'
          value={admin_notes}
          onChange={(event) => setAdminNotes(event.target.value)}
        />
      </p>
      <Button disabled={!isValid()} onClick={save}>
        Risolvi
      </Button>
    </form>
  )
}
